<template>
  <div class="contact" id="contact">
    <div class="container">
      <div class="contact__wrapper">
        <h2 class="contact__title">Contact Us!</h2>
        <input
            class="contact__input"
            type="text"
            v-model="name"
            placeholder="Name"
        >
        <input
            class="contact__input"
            type="email"
            v-model="email"
            placeholder="Email"
        >
        <textarea
            class="contact__textarea"
            v-model="message"
            placeholder="Your message..."
        />
        <button class="contact__button" @click="sendEmail">
          Get In Touch
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5002 7.5L20.0002 12M20.0002 12L15.5002 16.5M20.0002 12H4.00024" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {ElNotification} from "element-plus";

const name = ref('')
const email = ref('')
const message = ref('')

const sendEmail = async () => {
  const res = await fetch('https://api.lunatrixltd.com/api/send-email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      name: name.value,
      email: email.value,
      message: message.value,
    })
  })

  ElNotification({
    message: 'We will contact you as soon as possible!',
    type: 'success'
  })

  email.value = ""
  name.value = ""
  message.value = ""
}
</script>

<style lang="scss" scoped>
.contact {
  background-image: url(@images/heroBg.png);
  -webkit-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  padding-block: 150px 100px;

  &__wrapper {
    border-radius: 12px;
    background-color: $white;
    box-shadow: 0 0 30px 0 rgba(39, 35, 67, 0.12);
    padding: 40px 65px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__title {
    text-align: center;
    color: #272343;
    font-size: 32px;
    font-weight: 600;
    text-transform: capitalize;
  }

  &__input {
    border-radius: 8px;
    opacity: 0.7;
    background-color: #F0F2F3;
    padding: 17px 20px;

    color: #5a5a60;
    font-size: 16px;
    font-weight: 400;

    &::placeholder {
      color: #9A9CAA;
    }
  }

  &__textarea {
    resize: none;
    height: 200px;
    border-radius: 8px;
    opacity: 0.7;
    background-color: #F0F2F3;
    padding: 17px 20px;

    color: #5a5a60;
    font-size: 16px;
    font-weight: 400;

    &::placeholder {
      color: #9A9CAA;
    }
  }

  &__button {
    cursor: pointer;
    border-radius: 8px;
    background-color: #029FAE;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    transition: 0.2s;
    padding-block: 14px;

    color: $white;
    font-size: 16px;
    font-weight: 600;
    line-height: 110%;
    text-transform: capitalize;

    @include hover {
      background-color: #00717c;
    }
  }
}

@media (max-width: 500px) {
  .contact {
    &__wrapper {
      padding: 30px 35px;
    }
  }
}
</style>